module.exports = __webpack_public_path__ + "media/images/navbar/fabrique-3266a9b4dc08bb1576c2bb94e34169cb.png";